import { c as _c } from "react/compiler-runtime";
import { CountdownTimer } from '@/components/molecule/CountdownTimer';
import { INVITE_COMMON_CONFIG } from '../../../constants';
import { ShareButtons } from './ShareButtons';
export const BottomSection = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CountdownTimer endDate={INVITE_COMMON_CONFIG.event.endDate} label={"\uB9C8\uAC10\uAE4C\uC9C0"} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="sticky bottom-0 w-full">{t0}<div className="w-full bg-Gray-black/25 backdrop-blur-md"><ShareButtons endDate={INVITE_COMMON_CONFIG.event.endDate} /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};